import React from 'react';
import { Link } from 'react-router-dom';

import './Nav.scss';

class Nav extends React.Component {
  render() {
    return (
      <nav className="nav">
        <div className="nav__links">
          <Link to="/" className="nav__links__logo"></Link>
        </div>
      </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/nav/Nav.jsx